import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';

import { useDetectWakeUpMode } from '@gem/call/hooks/useDetectWakeUpMode/useDetectWakeUpMode';

import { CallPushNotification } from './CallPushNotification/CallPushNotification';
import { CallContext, ICallContext } from './CallView.context';
import { CallViewContainer } from './CallViewContainer/CallViewContainer';
import { PermissionsRequestHandler } from './PermissionsRequestHandler/PermissionsRequestHandler';
import { AudioSources } from './Shared/AudioSources/AudioSources';

interface OngoingCallViewProps {
  state: ICallContext;
  groupRoute?: string;
}

export const CallView = observer<OngoingCallViewProps>(({ state, groupRoute }) => {
  const callback = useCallback(() => {
    // state.callController.unpublish();
  }, []);

  useDetectWakeUpMode(
    callback,
    !state.call.meStore.isVideoMuted || !state.call.meStore.isAudioMuted
  );

  return (
    <CallContext.Provider value={state}>
      {state.call ? (
        <>
          {/* ToDo: [CALLS-B2B] избавиться от PermissionsRequestHandler и перенести в контроллер */}
          <PermissionsRequestHandler />
          <CallViewContainer minimisedViewRedirectPath={groupRoute} />
          {/* ToDo: [CALLS-B2B] в идеале перенести в контроллер */}
          {state.call.isMeInitiator && <CallPushNotification redirectRoutePath={groupRoute} />}
          <AudioSources />
        </>
      ) : null}
    </CallContext.Provider>
  );
});
